import React, {useState} from 'react';
import PrimaryButton from '../../ui/PrimaryButton';
import {EmailNotificationTemplate, EmailTemplateType, PlatformEventKind} from '../../schema';
import If from '../utils/If';
import EmailNotification from '../emailTemplate/EmailNotification';

type FormProps = {
  licenseTypeId: string;
  templates: EmailNotificationTemplate[],
}

export default function Form({licenseTypeId, templates}: FormProps) {
  const [addMode, setAddMode] = useState(false);

  return (
    <div>
      <div className="mb-5">
        You can send out up to 5 automatic notifications on configured triggers. After you save the changes, the
        notifications will arrange themselves in the desired sequence
      </div>
      {templates.map((template) => (
        <EmailNotification
          key={template.id}
          objectType={EmailTemplateType.license_type}
          allowedEvents={[PlatformEventKind.License_Expired]}
          template={template}
          objectId={licenseTypeId}
          onSuccess={() => setAddMode(false)}
        />
      ))}
      <If condition={addMode}>
        <EmailNotification objectId={licenseTypeId} onCancel={() => setAddMode(false)}
                           allowedEvents={[PlatformEventKind.License_Expired]}
                           refetchQueries={['EditRenewalTemplatesQuery', 'templates']}
                           objectType={EmailTemplateType.license_type}
                           onSuccess={() => setAddMode(false)}/>
      </If>
      <If condition={templates.length < 5 && !addMode}>
        <PrimaryButton className="mt-3" onClick={() => setAddMode(true)}> Add renewal notification</PrimaryButton>
      </If>
    </div>
  );
}
